module.exports = __webpack_public_path__ + "media/img/icon3-4817ffed2a00cbd31b4d46163cce2ac2.svg";